import { Children, Fragment, useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { motion, useMotionValue, useMotionValueEvent } from "framer-motion";

const Carousel = ({ children, initialIndex, autoSlide }) => {
  const DRAG_BUFFER = 50 * 3;

  const childs = Children.toArray(children);

  const [activeTab, setActiveTab] = useState(initialIndex);
  const [dragging, setDragging] = useState(false);

  const dragX = useMotionValue(0);
  const dragXProgress = useMotionValue(0);
  const [hold, setHold] = useState(false);

  useMotionValueEvent(dragX, "change", (latest) => {
    if (typeof latest === "number" && dragging) {
      dragXProgress.set(latest);
    } else {
      dragXProgress.set(0);
    }
  });

  const handleNext = () => {
    if (hold) {
      return;
    }
    setHold((prev) => true);
    setActiveTab((prev) => {
      if (prev === childs.length - 1) {
        return 0;
      }
      return prev + 1;
    });

    return;
  };

  const handlePrevious = () => {
    if (hold) {
      return;
    }
    setHold((prev) => true);
    setActiveTab((prev) => {
      if (prev === 0) {
        return childs.length - 1;
      }
      return prev - 1;
    });
    return;
  };

  const onDragStart = () => {
    console.log("On Drag Start");
    setDragging(true);
  };

  const onDragEnd = () => {
    console.log("On Drag End");
    setDragging(false);
    const x = dragX.get();
    if (x <= -DRAG_BUFFER && activeTab < childs.length - 1) {
      handleNext();
    } else if (x >= DRAG_BUFFER && activeTab > 0) {
      handlePrevious();
    }
  };

  const handleAnimationComplete = async () => {
    setHold((prev) => false);
  };

  useEffect(() => {
    if (autoSlide) {
      const time = 7000;
      const x = dragXProgress.get();
      const interval = setInterval(() => {
        if (x === 0) {
          handleNext();
        }
      }, time);
      return () => clearInterval(interval);
    }
  }, [activeTab, hold, autoSlide]);

  return (
    <>
      <div className="relative">
        <motion.div
          drag="x"
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          dragConstraints={{
            left: 0,
            right: 0,
          }}
          style={{ x: dragX }}
          animate={{
            translateX: `-${activeTab * 100}%`,
          }}
          transition={{ ease: "linear", duration: 0.75 }}
          onAnimationComplete={handleAnimationComplete}
          className="flex"
        >
          {childs.map((item, idx) => {
            return <Fragment key={idx}>{item}</Fragment>;
          })}
        </motion.div>

        <div className="absolute bottom-10 left-1/2 flex -translate-x-1/2 gap-2">
          {childs.map((_, idx) => {
            return (
              <button
                onClick={() => setActiveTab((prev) => idx)}
                key={idx}
                className={`size-[10px] rounded-full text-white transition-all duration-300 ${activeTab === idx ? "scale-105 bg-slate-50" : "scale-90 bg-neutral-500"}`}
              ></button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Carousel;
